import React from 'react';
import { DropDownFilter, FilterInputDecorator, useFilterContext } from 'framework/list';
import { UiThemeOverrider } from 'framework/uiTheme';
import PersonTimelineFilterButtonLayout from './PersonTimelineFilterButtonLayout';

interface PersonTimelineRecordTypeFilterProps {
  cleanableFilters?: string[];
  source: string;
  dropdownComponent: React.ComponentType<any>;
  [key: string]: any;
}

const PersonTimelineRecordTypeFilter = ({
  cleanableFilters = [],
  source,
  dropdownComponent: DropdownComponent,
  ...props
}: PersonTimelineRecordTypeFilterProps) => {
  const { filterBy } = useFilterContext();

  const onChangeCallback = (filter: any) => {
    const filters = {
      ...filter,
    };

    cleanableFilters.forEach((clearableFilter: string) => {
      filters[clearableFilter] = {};
    });

    filterBy(filters);
  };

  return (
    <UiThemeOverrider
      overriddenLayouts={{
        DropdownLayout: PersonTimelineFilterButtonLayout,
      }}
    >
      <DropDownFilter {...props} source={source} isSingle onChangeCallback={onChangeCallback}>
        <FilterInputDecorator cleanableFilters={[...cleanableFilters, source]}>
          <DropdownComponent {...props} />
        </FilterInputDecorator>
      </DropDownFilter>
    </UiThemeOverrider>
  );
};

export default PersonTimelineRecordTypeFilter;
